
import { supabase } from '../../supabase';
import { DailyStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get daily statistics
 */
export const getDailyStats = async (
  startDate: Date, 
  endDate: Date, 
  authFilter: AuthFilter = 'all'
): Promise<DailyStat[]> => {
  const { data, error } = await supabase.rpc('get_daily_stats_aggregated', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error('Error fetching daily stats:', error);
    throw error;
  }
  
  // Initialize all dates in range with 0 counts for UI continuity
  const dateCounts: Record<string, number> = {};
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    const dateStr = currentDate.toISOString().split('T')[0];
    dateCounts[dateStr] = 0;
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  // Merge database results
  data?.forEach(item => {
    const dateStr = item.date;
    dateCounts[dateStr] = Number(item.count);
  });
  
  return Object.entries(dateCounts).map(([date, count]) => ({
    date,
    count
  })).sort((a, b) => a.date.localeCompare(b.date));
};
